import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface MerchantInfoProps {
  merchantName?: string
  email?: string
  phone?: string
  rootStyle?: stylex.StyleXStyles
}

export const MerchantInfo = ({ merchantName, email, phone, rootStyle }: MerchantInfoProps) => {
  const { t } = useTranslation()
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">{t('orderDetail.dealerInfo', { defaultValue: '經銷商資訊' })}</Text>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.dealerName', { defaultValue: '經銷商名稱' })}</Text>
        <Text variant="body">{merchantName}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.recipientEmail', { defaultValue: 'Email' })}</Text>
        <Text variant="body">{email}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.recipientPhone', { defaultValue: '聯絡電話' })}</Text>
        <Text variant="body">{phone}</Text>
      </Box>
    </VStack>
  )
}
